import React from "react";
import Subtitle from "../../../../components/Subtitle";
import CardFull from "../card/full";
import styles from "./exclusiones.module.css";
import ExclusionesList from "../../../../components/ExclusionesList";

const Exclusiones = ({ exclusiones }) => {
    return (
        <React.Fragment>
            {exclusiones !== undefined && exclusiones !== null && exclusiones.length > 0
                ? <div className={styles.container__full}>
                    <CardFull>
                        <Subtitle sname="Principales exclusiones" mostrar="true" />
                        <div className={styles.container__wrapper}>
                            <div className={styles.descripCard}>
                            </div>
                            {/* CARDS EXCLUSIONES */}
                            <div className={styles.exclusiones__wrapper}>
                                <ExclusionesList exclusiones={exclusiones} />
                            </div>
                        </div>
                    </CardFull>
                </div>
                : null
            }
        </React.Fragment>
    )
}

export default Exclusiones;